import Link from 'next/link';
import { RiArrowRightLine, RiMailLine, RiPhoneLine } from 'react-icons/ri';

import { DomStankovLogo } from '../header/DomStankovLogo';

export const Footer = () => (
  <footer className="site-footer" id="contacts">
    <div className="footer-grid container">
      <div className="footer-brand">
        <Link href="/" aria-label="Дом Станков — главная">
          <DomStankovLogo />
        </Link>
        <p>
          Оборудование для производства.
          <br />
          Решения для вашего бизнеса.
        </p>
        <a className="text-link" href="mailto:zakaz@domstankov.com">
          Обсудить задачу
          <RiArrowRightLine />
        </a>
      </div>
      <div>
        <h3>Оборудование</h3>
        <Link href="/catalog/1e875ded-f8bc-490d-8389-bb3d07990250">Металлообработка</Link>
        <Link href="/catalog/4fa9cbf3-ffd4-4647-8209-b62eb2923440">Деревообработка</Link>
        <Link href="/catalog/8976e358-9ddb-42d7-a689-927353a3f08f">Мебельное производство</Link>
        <Link href="/catalog/1af56996-9eef-4d7a-80f3-ea03593039db">Компрессоры</Link>
        <Link href="/catalog/9d69b166-1a39-4073-b952-d24432f89128">Окрасочное оборудование</Link>
      </div>
      <div>
        <h3>Компания</h3>
        <Link href="/#about">О компании</Link>
        <Link href="/delivery-and-payment">Доставка и оплата</Link>
        <Link href="/requisites">Реквизиты</Link>
        <Link href="/offer">Оферта</Link>
        <Link href="/privacy-policy">Политика конфиденциальности</Link>
        <Link href="/personal-data">Обработка персональных данных</Link>
      </div>
      <div className="footer-contact">
        <h3>На связи с вашим производством</h3>
        <a href="tel:+73433630507">
          <RiPhoneLine />
          +7 (343) 363-05-07
        </a>
        <a href="mailto:zakaz@domstankov.com">
          <RiMailLine />
          zakaz@domstankov.com
        </a>
        <p>Пн–Пт: 10:00–19:00</p>
        <div className="footer-socials">
          <a href="https://vk.com/club224366530" target="_blank" rel="noreferrer">
            ВКонтакте ↗
          </a>
          <a href="https://www.youtube.com/channel/UCuyarkO4X5E9diphoHV0ysw" target="_blank" rel="noreferrer">
            YouTube ↗
          </a>
        </div>
      </div>
    </div>
    <div className="footer-bottom container">
      <span>© {new Date().getFullYear()} Дом Станков</span>
      <span>Точность начинается с выбора.</span>
      <Link href="/privacy-policy">Конфиденциальность</Link>
      <button
        className="cookie-settings"
        type="button"
        onClick={() => window.dispatchEvent(new Event('domstankov:privacy-settings'))}
      >
        Настройки cookies
      </button>
    </div>
  </footer>
);
